import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiResponseModel, ApiVisa, Pagination } from '../../shared';
import { Observable } from 'rxjs';
import { MrpOutstandingQtyRequestDto, MrpOutstandingQtyResponseDto } from '../../../../../../models/aggregates/erp/stock/mrp-outstanding-qty-dto.model';
import { MrpOutstandingReportDto } from '../../../../../../models/aggregates/erp/stock/mrp-outstanding-report-dto.model';

@Injectable({
  providedIn: 'root'
})
export class MrpOutstandingReportService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/outstanding-reports"

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/outstanding-reports"
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/outstanding-reports"
    this.httpClient = http;
  }

  public generateExportFile(pagination: Pagination, apiVisa: ApiVisa): Observable<Blob> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria = this.apiUrl + '/generate-csv/'
      + Core2Config.BACKOFFICE_EP_SUFFIX + '?' + pagination.getQueryKeyValues();
    return this.httpClient.get<Blob>(UrlByCriteria, this.getHttpHeaderBlob(apiVisa));
  }

  public getOutstandingQty(dto: MrpOutstandingQtyRequestDto, visa: ApiVisa): Observable<any> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + Core2Config.BACKOFFICE_EP_SUFFIX + "/outstanding-qty";
    }
    return this.httpClient.post<ApiResponseModel<MrpOutstandingQtyResponseDto>>(this.apiUrl, dto, this.getHttpHeader(visa));
  }

  public getOutstandingReportsByCriteria(pagination: Pagination, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria = this.apiUrl + '/' + Core2Config.BACKOFFICE_EP_SUFFIX + '?' + pagination.getQueryKeyValues();
    return this.httpClient.get<ApiResponseModel<MrpOutstandingReportDto>>(UrlByCriteria, this.getHttpHeader(apiVisa));
  }
}
